import React, { useState } from 'react';

import { PassengerModal } from './PassengerModal';
import { PriceBreakdownModal } from './PriceBreakdownModal';
import { TravelerInfo } from './TravelerInfo';
import { TripInfo } from './TripInfo';
import Events from './events/TripSelectionSummaryEvents';

import styles from './TripSelectionSummary.scss';

import type { TripSelectionSummaryProps } from './types';

const TripSelectionSummary = ({
    itineraryId = '',
    maxSeats = 1,
    maxWheelchairs = 0,
    minSeats = 1,
    minWheelchairs = 0,
    nonAdaCarriers = [],
    requestedWheelchairs = 0,
    seats = 1,
    wheelchairs = 0,
}: TripSelectionSummaryProps) => {
    const [isPassengerModalOpen, setIsPassengerModalOpen] = useState(false);
    const [isPriceBreakdownModalOpen, setIsPriceBreakdownModalOpen] = useState(false);

    const togglePassengerModal = () => {
        Events.addTravelerDropdownClicked({
            itineraryId,
            travelers: seats,
            wheelchairs,
        });
        setIsPassengerModalOpen(!isPassengerModalOpen);
    };

    const togglePriceBreakdownModal = () => {
        setIsPriceBreakdownModalOpen(!isPriceBreakdownModalOpen);
    };

    return (
        <div className={styles.tripSelectionSummary}>
            <TravelerInfo
                itineraryId={itineraryId}
                seats={seats}
                togglePassengerModal={togglePassengerModal}
            />

            {isPassengerModalOpen && <PassengerModal
                itineraryId={itineraryId}
                maxSeats={maxSeats}
                maxWheelchairs={maxWheelchairs}
                minSeats={minSeats}
                minWheelchairs={minWheelchairs}
                nonAdaCarriers={nonAdaCarriers}
                requestedWheelchairs={requestedWheelchairs}
                seats={seats}
                togglePassengerModal={togglePassengerModal}
                wheelchairs={wheelchairs}
            />}

            <TripInfo
                itineraryId={itineraryId}
                togglePriceBreakdownModal={togglePriceBreakdownModal}
            />

            {isPriceBreakdownModalOpen && <PriceBreakdownModal
                isOpen={isPriceBreakdownModalOpen}
                itineraryId={itineraryId}
                onOpenChange={togglePriceBreakdownModal}
            />}
        </div>
    );
};

export { TripSelectionSummary };
